import React, { Component } from "react";
import { connect } from "react-redux";
import LoadingPage from "./LoadingPage";
import { firebase } from "../firebase/firebase";
import {
  imageUpload,
  clearItems,
  imageInit,
  uploadItem,
  itemsFetch,
  refFetch,
} from "../actions";

class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = { image: null, loading: false, description: "", ref: false };
    props.itemsFetch();
    props.refFetch();
  }

  imageUpload(e) {
    e.preventDefault();
    this.props.imageUpload(this.state.image, "Items/");
    this.setState({ description: this.refs.textarea.value, loading: true });
  }

  imageRefUpload(e) {
    e.preventDefault();
    this.props.imageUpload(this.state.image, "Items/");
    this.setState({
      description: this.refs.textareaRef.value,
      loading: true,
      ref: true,
    });
  }

  componentWillReceiveProps({ done, urls }) {
    if (done && !this.uploaded) {
      this.uploaded = true;
      this.props.uploadItem(urls[0], this.state.description, this.state.ref);
    }
  }

  componentWillUnmount() {
    this.props.imageInit();
  }

  renderItems() {
    return Object.entries(this.props.items).map(item => (
      <img
        className="del-images"
        key={item[0]}
        src={item[1].image}
        onClick={() => {
          if (confirm("Biztos törli?"))
            firebase
              .database()
              .ref("Item")
              .child(item[0])
              .remove()
              .then(() => {
                alert("Törölve!");
                location.reload();
              });
        }}
      />
    ));
  }

  renderRefs() {
    return Object.entries(this.props.refs).map(item => (
      <img
        className="del-images"
        key={item[0]}
        src={item[1].image}
        onClick={() => {
          if (confirm("Biztos törli?"))
            firebase
              .database()
              .ref("Reference")
              .child(item[0])
              .remove()
              .then(() => {
                alert("Törölve!");
                location.reload();
              });
        }}
      />
    ));
  }

  render() {
    if (this.state.loading || !this.props.items || !this.props.refs)
      return <LoadingPage />;
    return (
      <div>
        <form
          style={{ textAlign: "center", color: "white" }}
          onSubmit={e => this.imageUpload(e)}>
          <h1>Admin oldal</h1>
          <h3>Feltöltés</h3>
          <div>Kép</div>
          <input
            type="file"
            accept="image/*"
            required
            onChange={e => {
              const reader = new FileReader();
              reader.onload = function() {
                document.getElementById("image").src = reader.result;
              };
              reader.readAsDataURL(e.target.files[0]);
              this.setState({ image: e.target.files });
            }}
          />
          <br />
          {this.state.image && (
            <img
              style={{ width: 450, height: 300, objectFit: "cover" }}
              id="image"
              src=""
            />
          )}
          <br />
          <div>Leírás</div>
          <textarea style={{ width: 300 }} rows={5} ref="textarea" />
          <br />
          <button type="submit">FELTÖLT</button>
          <br />
          <br />
          <br />
        </form>
        <h3>Törlés</h3>
        {this.renderItems()}
        <br />
        <br />
        <br />
        <form
          style={{ textAlign: "center", color: "white" }}
          onSubmit={e => this.imageRefUpload(e)}>
          <h3>Referencia kép feltöltés</h3>
          <div>Kép</div>
          <input
            type="file"
            accept="image/*"
            required
            onChange={e => {
              const reader = new FileReader();
              reader.onload = function() {
                document.getElementById("reference").src = reader.result;
              };
              reader.readAsDataURL(e.target.files[0]);
              this.setState({ image: e.target.files });
            }}
          />
          <br />
          {this.state.image && (
            <img
              style={{ width: 450, height: 300, objectFit: "cover" }}
              id="reference"
              src=""
            />
          )}
          <br />
          <div>Leírás</div>
          <textarea style={{ width: 300 }} rows={5} ref="textareaRef" />
          <br />
          <button type="submit">FELTÖLT</button>
        </form>
        <h3>Törlés</h3>
        {this.renderRefs()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    urls: state.image.urls,
    done: state.image.done,
    items: state.fetch.items,
    refs: state.fetch.refs,
  };
};

export default connect(
  mapStateToProps,
  {
    imageUpload,
    clearItems,
    imageInit,
    uploadItem,
    itemsFetch,
    refFetch,
  }
)(Admin);



// WEBPACK FOOTER //
// ./src/components/Admin.js